import {
  AspectRatio,
  Box,
  Button,
  Card,
  CardBody,
  HStack,
  Heading,
  Link,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { FC } from "react";

import {
  GatsbyImage,
  getImage,
  IGatsbyImageData,
  StaticImage,
} from "gatsby-plugin-image";
import { MdArrowForwardIos, RiCalendarEventLine } from "../../customIcons";

type BlogCardType = {
  imageData?: IGatsbyImageData;
  category?: string;
  title?: string;
  description?: string;
  author?: string;
  date?: string;
  backgroundColor: string;
  slug?: string;
  input?: boolean;
  authorSlug?: any;
};

const BlogCard: FC<BlogCardType> = ({
  imageData,
  category,
  title,
  description,
  date,
  backgroundColor,
  slug,
  input,
  author,
  authorSlug,
}) => {
  const image = imageData ? getImage(imageData) : null;

  return (
    <Card
      bg={backgroundColor}
      boxShadow="0px 1px 2px 0px rgba(0, 0, 0, 0.05)"
      border="1px solid #E2E8F0"
      maxW="415px"
      w="full"
      mx="auto"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
    >
      <CardBody padding="0px">
        <Box p="8px" position="relative">
          <AspectRatio ratio={{ base: 21 / 9, md: 3 / 2 }}>
            <Link href={`${slug}/`}>
              {image ? (
                <GatsbyImage
                  image={image}
                  alt="Blog Featured Image"
                  objectFit="cover"
                  style={{ height: "100%", width: "100%" }}
                />
              ) : (
                <StaticImage
                  rel="preload"
                  src="../../../images/placeholderBlog.webp"
                  alt="Blog Featured Image"
                  objectFit="cover"
                  layout="fullWidth"
                  style={{
                    height: "100%",
                    width: "100%",
                    backgroundColor: "transparent !important",
                  }}
                />
              )}
            </Link>
          </AspectRatio>
          <Text
            px={2}
            h={5}
            display={"flex"}
            alignItems={"center"}
            bg="#FFE9F3"
            fontWeight="500"
            color="#7F3451"
            borderRadius="4px"
            position="absolute"
            top={6}
            right={2}
            fontSize="14px"
            textAlign="center"
          >
            {category}
          </Text>
        </Box>

        <Stack px="12px" mt="12px" spacing="3">
          <HStack justifyContent="space-between">
            <HStack>
              <RiCalendarEventLine fill="#fff" w="16px" h="16px" />
              <Text fontSize="14px" color="#4A5568">
                {date}
              </Text>
            </HStack>
            {author && (
              <Link href={`/blog/author/${authorSlug}/`}>
                <Text fontSize="14px" color="#BB5D82">
                  {author}
                </Text>
              </Link>
            )}
          </HStack>
          <VStack alignItems="flex-start" gap={0}>
            <Heading as="h4" size="md">
              <Link
                href={`${slug}/`}
                _hover={{ textDecoration: "none", color: "#3B2060" }}
              >
                {title}
              </Link>
            </Heading>
            <Text pt="12px" fontSize="14px" color="#4A5568" noOfLines={4}>
              {description}
            </Text>
          </VStack>
        </Stack>
      </CardBody>

      {input && (
        <Box px="8px">
          <Link href={`${slug}/`}>
            <Button
              w="100%"
              fontSize="16px"
              color="#3B2060"
              fontWeight="600"
              variant="outline"
              border="1px solid #3B2060"
              _hover={{ bg: "#F3EBFF" }}
              mb="12px"
              mt="20px"
              rightIcon={<MdArrowForwardIos w="16px" h="16px" />}
            >
              Read More
            </Button>
          </Link>
        </Box>
      )}
    </Card>
  );
};

export default BlogCard;
